import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { SwiperGoods } from './SwiperGoods';
import { SwiperWhole } from './SwiperWhole';

/* 개발담당:양유빈
 * 화면기능:스와이프 처리
 * 세부설명:
*/

export class SwiperContainer extends Component {
    static displayName = SwiperContainer.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: ""
        };
        this.index = -1;
    }
    //초기화
    componentDidMount() {
        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        if (ContentConmgr !== null) {            
            this.setState({ ContentConmgr: ContentConmgr});
        }
    }
   
    render() {
        const ContentConmgr = this.state.ContentConmgr;
        const cntt_tye = ContentConmgr.cntt_tye;
        const mgr_no = ContentConmgr.mgr_no;
        const index = this.index;
        if (cntt_tye === "GO") {
            return (
                <SwiperGoods key={`${mgr_no}_${index}`}
                    data-info={ContentConmgr}
                    GoodsDtlShow={this.props.GoodsDtlShow}
                />
            )
        }
        else if (cntt_tye === "WH") {
            return (
                <SwiperWhole key={`${mgr_no}_${index}`}
                    data-info={ContentConmgr}
                />
            )
        }
        else {
            return (
                "컨텐츠준비중입니다."
            )
        }
    }
}
